import React, { useState, useEffect } from 'react';

export const threadData1 = [
    {
        _id: 0,
        text: 'Hi there!',
        createdAt: new Date(Date.UTC(2020, 9, 29, 17, 20, 0)),
        user: {
            _id: 2,
            name: 'Jane'
        }
    },
    {
        _id: 1,
        text: 'I would like to get to know you',
        createdAt: new Date(Date.UTC(2020, 9, 29, 17, 25, 0)),
        user: {
            _id: 2,
            name: 'Jane'
        }
    }
]

export const threadData2 = [
    {
        _id: 0,
        text: 'Howdy!',
        createdAt: new Date(Date.UTC(2020, 9, 29, 17, 20, 0)),
        user: {
            _id: 2,
            name: 'Jane'
        }
    },
    {
        _id: 1,
        text: 'What up?',
        createdAt: new Date(Date.UTC(2020, 9, 29, 17, 25, 0)),
        user: {
            _id: 2,
            name: 'Jane'
        }
    }
]